import React, { useRef, useState } from 'react';
import IoElement from '../IOElement';
import AnchorTag from '../AnchorTag';
import Wrapper from '../../layouts/ImageVideoWrapper';
import useScaleUrl from '../../hooks/ScaleUrl';
const BANNER_IMAGE = 'banner image';
const Video = (widgetData) => {
    const video = useRef(null);
    const [err, setErr] = useState(false);
    const { params, isDesktop, isServer, trackingData, } = widgetData;
    const { url, src, thumbnail, columnsInRow, } = params;
    const { scaleUrl } = useScaleUrl(src, isDesktop, columnsInRow);
    const { scaleUrl: scaleThumbnail } = useScaleUrl(thumbnail, isDesktop, columnsInRow);
    const handlePlay = () => {
        /**
         * To restart the video need to set currentTime to the initail
         * Tried load() event also but its shows jerking if we come again
         * into the view port
         */
        if (video.current.paused && video.current.currentTime > 0) {
            video.current.currentTime = '0.01';
        }
        video.current.play();
    };
    const handleEmptyIntersect = () => {
    }; // this is need we need only one intersect at a time.
    const handlePause = () => {
        if (video.current.currentTime > 0) {
            video.current.pause();
        }
    };
    const handleError = () => {
        setErr(true);
    };
    const { namespace2 } = trackingData;
    const altText = namespace2 || BANNER_IMAGE;
    return (React.createElement(IoElement, { onIntersect: handleEmptyIntersect, onIntersectV2: handlePlay, isServer: isServer, exitCallBack: handlePause },
        React.createElement(Wrapper, { className: "image-wrapper", params: params, isDesktop: isDesktop },
            React.createElement(AnchorTag, { url: url }, err ? (React.createElement("img", { alt: altText, src: scaleThumbnail, loading: "eager" })) : (React.createElement("video", { onError: handleError, ref: video, loop: true, muted: true },
                React.createElement("source", { src: scaleUrl, type: "video/mp4" })))))));
};
export default Video;
